import { action } from "satcheljs";
import type LayoutChangeSource from "../store/schema/LayoutChangeSource";

export interface ReevaluateHeightBucketActionMessage {
    source: LayoutChangeSource;
}
export const reevaluateHeightBucket: (source: LayoutChangeSource) => ReevaluateHeightBucketActionMessage = action("reevaluateHeightBucket", (source: LayoutChangeSource): ReevaluateHeightBucketActionMessage => ({
    source,
}));
